<div class="dialog-wrapper">
  <h2 mat-dialog-title>{{ "brand.campaign.creation.title" | translate }}</h2>
  <mat-dialog-content>
    <div>
      <mat-form-field class="fieldset">
        <mat-label>{{ "campaigns.name" | translate }}</mat-label>
        <input
          matInput
          [(ngModel)]="campaign.name"
          name="campaign_name"
          type="text"
          required
        />
        <mat-error class="campaign_name-error">
          {{ "brand.campaign.creation.nameRequired" | translate }}
        </mat-error>
      </mat-form-field>
    </div>
    <div class="type-selection">
      <h3>{{ "brand.campaign.creation.selectType" | translate }}</h3>
      <div class="checkbox-select">
        <div
          class="checkbox-select__option"
          (click)="selectType(CampaignType.DownloadOnly)"
          [ngClass]="{
            active:
              hasAccess(CampaignType.DownloadOnly) &&
              campaign.type === CampaignType.DownloadOnly,
            disabled: !hasAccess(CampaignType.DownloadOnly),
            clickable: hasAccess(CampaignType.DownloadOnly)
          }"
        >
          <div data-option="ONLY_DOWNLOAD_AREA">
            <span class="checkbox-select__option__title">{{
              "shared.campaignType.ONLY_DOWNLOAD_AREA" | translate
            }}</span>
            <p class="checkbox-select__option__text">
              {{
                "brand.campaign.creation.contentOnly.description" | translate
              }}
            </p>
          </div>
          <mat-icon
            *ngIf="hasAccess(CampaignType.DownloadOnly)"
            class="checkbox-select__option__check"
            >check</mat-icon
          >
        </div>
        <div
          class="checkbox-select__option"
          (click)="selectType(CampaignType.DownloadOnlyWithShortLink)"
          [ngClass]="{
            active:
              hasAccess(CampaignType.DownloadOnlyWithShortLink) &&
              campaign.type === CampaignType.DownloadOnlyWithShortLink,
            disabled: !hasAccess(CampaignType.DownloadOnlyWithShortLink),
            clickable: hasAccess(CampaignType.DownloadOnlyWithShortLink)
          }"
        >
          <div data-option="ONLY_DOWNLOAD_AREA_WITH_SHORT_LINK">
            <span class="checkbox-select__option__title">{{
              "shared.campaignType.ONLY_DOWNLOAD_AREA_WITH_SHORT_LINK"
                | translate
            }}</span>
            <p class="checkbox-select__option__text">
              {{
                "brand.campaign.creation.landingPage.description" | translate
              }}
            </p>
          </div>
          <mat-icon
            *ngIf="hasAccess(CampaignType.DownloadOnlyWithShortLink)"
            class="checkbox-select__option__check"
            >check</mat-icon
          >
        </div>
        <div
          class="checkbox-select__option"
          (click)="selectType(CampaignType.Contest)"
          [ngClass]="{
            active:
              hasAccess(CampaignType.Contest) &&
              campaign.type === CampaignType.Contest,
            disabled: !hasAccess(CampaignType.Contest),
            clickable: hasAccess(CampaignType.Contest)
          }"
        >
          <div data-option="CONTEST">
            <span class="checkbox-select__option__title">{{
              "shared.campaignType.CONTEST" | translate
            }}</span>
            <p class="checkbox-select__option__text">
              {{ "brand.campaign.creation.sweepstake.description" | translate }}
            </p>
          </div>
          <mat-icon
            *ngIf="hasAccess(CampaignType.Contest)"
            class="checkbox-select__option__check"
            >check</mat-icon
          >
        </div>
        <div
          class="checkbox-select__option"
          (click)="selectType(CampaignType.ProductTester)"
          [ngClass]="{
            active:
              hasAccess(CampaignType.ProductTester) &&
              campaign.type === CampaignType.ProductTester,
            disabled: !hasAccess(CampaignType.ProductTester),
            clickable: hasAccess(CampaignType.ProductTester)
          }"
        >
          <div data-option="PRODUCT_TESTER">
            <span class="checkbox-select__option__title">{{
              "shared.campaignType.PRODUCT_TESTER" | translate
            }}</span>
            <p class="checkbox-select__option__text">
              {{
                "brand.campaign.creation.productTester.description" | translate
              }}
            </p>
          </div>
          <mat-icon
            *ngIf="hasAccess(CampaignType.ProductTester)"
            class="checkbox-select__option__check"
            >check</mat-icon
          >
        </div>
        <div
          class="checkbox-select__option"
          (click)="selectType(CampaignType.Beta)"
          [ngClass]="{
            active:
              hasAccess(CampaignType.Beta) &&
              campaign.type === CampaignType.Beta,
            hidden: !hasAccess(CampaignType.Beta),
            clickable: hasAccess(CampaignType.Beta)
          }"
        >
          <div data-option="BETA">
            <span class="checkbox-select__option__title">{{
              "shared.campaignType.BETA" | translate
            }}</span>
            <p class="checkbox-select__option__text">
              {{ "brand.campaign.creation.beta.description" | translate }}
            </p>
          </div>
          <mat-icon
            *ngIf="hasAccess(CampaignType.Beta)"
            class="checkbox-select__option__check"
            >check</mat-icon
          >
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button class="button-white" [mat-dialog-close]="" [disabled]="isCreating">
      {{ "shared.cancel" | translate }}
    </button>
    <button
      class="button-orange"
      (click)="createCampaign()"
      [disabled]="isCreating || !campaign.name"
    >
      <span *ngIf="isCreating">{{ "shared.creating" | translate }}</span>
      <span *ngIf="!isCreating">{{
        "brand.campaign.creation.createButton" | translate
      }}</span>
    </button>
  </mat-dialog-actions>
</div>
